import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import TileFactory from "./base";
import RasterDataLayer from "./layers/rasterDataLayer";

var RasterTiffTile = /*#__PURE__*/function (_TileFactory) {
  _inherits(RasterTiffTile, _TileFactory);

  var _super = _createSuper(RasterTiffTile);

  function RasterTiffTile(option) {
    var _this;

    _classCallCheck(this, RasterTiffTile);

    _this = _super.call(this, option);
    _this.parentLayer = option.parent;
    return _this;
  }

  _createClass(RasterTiffTile, [{
    key: "createTile",
    value: function createTile(tile, initOptions) {
      var _this$parentLayer, _this$parentLayer$get, _this$parentLayer$get2;

      var colorTexture = initOptions.colorTexture,
          opacity = initOptions.opacity,
          domain = initOptions.domain,
          clampHigh = initOptions.clampHigh,
          clampLow = initOptions.clampLow,
          mask = initOptions.mask;
      var rasterData = tile.data;

      if (!rasterData.data) {
        console.warn('raster data not exist!');
        return {
          layers: [],
          layerIDList: []
        };
      }

      var dataType = (_this$parentLayer = this.parentLayer) === null || _this$parentLayer === void 0 ? void 0 : (_this$parentLayer$get = _this$parentLayer.getSource()) === null || _this$parentLayer$get === void 0 ? void 0 : (_this$parentLayer$get2 = _this$parentLayer$get.parser) === null || _this$parentLayer$get2 === void 0 ? void 0 : _this$parentLayer$get2.dataType;
      var layer = new RasterDataLayer({
        visible: tile.isVisible,
        mask: mask
      }).source(rasterData.data, {
        parser: {
          // 数据栅格分为单通道栅格和多通道彩色栅格
          type: dataType === 'rgb' ? 'rasterRgb' : 'raster',
          width: rasterData.width,
          height: rasterData.height,
          extent: tile.bboxPolygon.bbox
        }
      }).style({
        colorTexture: colorTexture,
        opacity: opacity,
        // TODO: 目前从 domain 从父瓦片图层的 style 进行配置，后续考虑从每个时机请求的栅格文件中进行配置
        domain: domain,
        clampHigh: clampHigh,
        clampLow: clampLow
      });
      this.emitRasterEvent([layer]);
      return {
        layers: [layer],
        layerIDList: [layer.id]
      };
    }
  }]);

  return RasterTiffTile;
}(TileFactory);

export { RasterTiffTile as default };